/**
 * tree_service_sarasota.jsx
 *
 * Sarasota location page — all customisation lives in this one config object.
 * Import LocationPage and pass your config. Done.
 */

import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css'; // shared styles

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/out_25.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image120.webp';
import slideImg2 from '../images/image36.webp';
import slideImg3 from '../images/image97_.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const sarasotaConfig = {
  
  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Sarasota Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming services in Sarasota, FL. Enhance the health and appearance of your trees with expert trimming and pruning.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_sarasota',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Sarasota',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Sarasota Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we handle the tough jobs other companies avoid.
     If you're dealing with overgrown, unstable, or dangerous trees in Sarasota,
     our team has the expertise to manage them safely and professionally.
     Whether branches are threatening your roof, carport, driveway, or power lines,
     we provide precision trimming and targeted removal to eliminate risk and
     improve tree health.`,

    `We specialize in <strong>dangerous</strong> and hazardous tree situations—storm-weakened limbs, leaning trunks,
     rotted sections, and overgrowth that puts your property at risk. From selective
     branch trimming to full canopy clearance, we tailor each service to your landscape's
     needs.`,

    `<strong>Sam's Tree Service</strong> delivers reliable, affordable, and expert tree care that keeps
     your property safe and your trees healthy across Sarasota and the surrounding
     <strong>Southwest Florida</strong> area.`,
  ],

  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Sarasota, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Sarasota = () => <LocationPage config={sarasotaConfig} />;

export default Services_Sarasota;
